/**
 * Marks a portaled descendant, such as the citation card or the date picker,
 * that `ReportCellPopover`'s outside-click guard must treat as inside.
 */
export const POPOVER_CHILD_CLASS = 'report-cell-popover-child';
